interface SapContactIdentity {
  id: string;
  displayId?: string;
}

export function matchesSapContactIdentifier(
  contact: SapContactIdentity,
  identifier: string | undefined | null
): boolean {
  const normalizedIdentifier = identifier?.trim();
  if (!normalizedIdentifier) {
    return false;
  }

  return contact.id === normalizedIdentifier || contact.displayId?.trim() === normalizedIdentifier;
}

export function findSapContactByIdentifier<T extends SapContactIdentity>(
  contacts: T[],
  identifier: string | undefined | null
): T | undefined {
  return contacts.find((contact) => matchesSapContactIdentifier(contact, identifier));
}
